import { render, staticRenderFns } from "./Idea.vue?vue&type=template&id=580c6268&scoped=true"
import script from "./Idea.vue?vue&type=script&lang=js"
export * from "./Idea.vue?vue&type=script&lang=js"
import style0 from "./Idea.vue?vue&type=style&index=0&id=580c6268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c6268",
  null
  
)

export default component.exports